import React from "react";
import { Box } from "@mui/material";

const CheckoutProduct = ({ item }) => {
	return (
		<Box>
			<Box sx={{ fontSize: "14px", color: "#424242" }}> {item.name}</Box>
			<Box>
				<img src={item.image} width="30" alt="" />
			</Box>
			<Box>Qauntity: {item.quantity}</Box>
		</Box>
	);
};

export default CheckoutProduct;
